<template>
    <div>
        <div class="flex justify-between items-center mb-6">
            <div v-if="isEdit" class="flex cursor-pointer text-green-600 hover:text-green-700" @click="goBack">
                <i class='bx bx-left-arrow-alt bx-sm my-auto'></i>
                <p class="text-xl font-semibold d-none d-md-block">Chỉnh sửa trang giới thiệu</p>
                <p class="text-xl font-semibold d-block d-md-none">Quay lại</p>
            </div>
            <p v-else class="text-xl font-semibold">Quản lý giới thiệu</p>
            <div>
                <div class="flex gap-1" v-if="isEdit">
                    <button @click="getEntry" class="admin-refresh-btn">
                        <i class='bx bx-refresh my-auto' ></i><p>Đặt lại</p>
                    </button>
                    <button @click="saveEntry" class="admin-save-btn">
                        <i class='bx bxs-save my-auto' ></i><p>Lưu</p>
                    </button>
                </div>
                <button @click="isEdit = true" v-else class="admin-edit-btn">
                    <i class='bx bxs-edit-alt text-black my-auto' ></i><p>Chỉnh sửa</p>
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-3">
                <div class="p-1 flex gap-2 px-3 py-1 bg-slate-600 text-white rounded-xl cursor-pointer" role="tab" v-b-toggle:home>
                    <h3 class="text-lg font-semibold text-left mb-0">Giới thiệu về HUET</h3>
                </div>
                <b-collapse visible class="px-3 py-2" id="home" accordion="my-accordion">
                    <b-form-group>
                        <label class="mb-1 text-lg d-flex align-items-center">
                            Lời mở đầu trang giới thiệu
                        </label>
                        <b-textarea :disabled="!isEdit" rows="5" v-model="entry.about" type="text" placeholder="Nhập lời mở đầu..." />
                    </b-form-group>
                </b-collapse>
            </div>
            <div class="col-12">
                <div class="mb-3" v-for="(item, index) in entry.target" :key="index">
                    <div class="p-1 flex gap-2 px-3 py-1 bg-slate-600 text-white rounded-xl cursor-pointer" role="tab" v-b-toggle="'target-' + index">
                        <h3 class="text-lg font-semibold text-left mb-0">Mục tiêu {{ index+1 }}</h3>
                    </div>
                    <b-collapse class="px-3 py-2" :id="'target-' + index" role="tabpanel" accordion="my-accordion">
                        <b-form-group>
                            <label class="mb-1 text-lg d-flex align-items-center">
                                Mục tiêu
                            </label>
                            <b-input :disabled="!isEdit" v-model="item.title" type="text" placeholder="Nhập tiêu đề..." />
                        </b-form-group>
                        <b-form-group>
                            <label class="mb-1 text-lg d-flex align-items-center">
                                Mô tả
                            </label>
                            <b-input :disabled="!isEdit" v-model="item.description" type="text" placeholder="Nhập mô tả..." />
                        </b-form-group>
                    </b-collapse>
                </div>
            </div>
            <div class="col-12 mb-3">
                <div class="p-1 flex gap-2 px-3 py-1 bg-slate-600 text-white rounded-xl cursor-pointer" role="tab" v-b-toggle:invitation>
                    <h3 class="text-lg font-semibold text-left mb-0">Thư mời tham gia HUET</h3>
                </div>
                <b-collapse class="px-3 py-2 row" id="invitation" accordion="my-accordion">
                    <div class="col-12 col-md-7 col-lg-8">
                        <b-form-group>
                            <label class="mb-1 text-lg d-flex align-items-center">
                                Tên giảng viên
                            </label>
                            <b-input :disabled="!isEdit" v-model="entry.invitation.title" type="text" placeholder="Nhập thông tin giảng viên..." />
                        </b-form-group>
                        <b-form-group>
                            <label class="mb-1 text-lg d-flex align-items-center">
                                Chi tiết thư mời
                            </label>
                            <b-textarea :disabled="!isEdit" rows="7" v-model="entry.invitation.description" type="text" placeholder="Nhập mô tả..." />
                        </b-form-group>
                    </div>
                    <b-form-group class="col-12 col-md-5 col-lg-4">
                        <label class="mb-1 text-lg d-flex align-items-center">
                            Ảnh thư mời
                        </label>
                        <b-form-file :disabled="!isEdit" ref="fileInput" v-model="file" accept="image/jpeg, image/png, image/gif, image/jpg, image/webp"></b-form-file>
                        <p v-if="error"  class="text-red-700 font-semibold">Lỗi: {{error}}</p>
                        <div class="mt-2 relative" v-if="entry.invitation.image">
                            <img class="object-cover w-full cursor-pointer rounded-lg min-h-[200px]" :src="$addPrefix(entry.invitation.image)" v-viewer alt @error="replaceBrokenImage">
                            <div @click="deleteImage" class="flex p-1 bg-white rounded-full absolute top-2 left-2 cursor-pointer">
                                <i class='bx bx-x' ></i>
                            </div>
                        </div>
                    </b-form-group>
                </b-collapse>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'manage-about',
    data() {
        return {
            webConfig: {},
            entry: {},
            isEdit: false,
            isSave: false,
            file: null,
            response: null,
            error: null,
        }
    },
    methods: {
        ...mapActions('webConfig', ['GetWebConfigList', 'UpdateWebConfig']),
        async getEntry() {
            let response = await this.GetWebConfigList()
            this.webConfig = response.data
            this.entry = this.webConfig.manageAbout
        },
        goBack() {
            this.getEntry()
            this.isEdit = false
        },
        additionalValidator() {
            for (let index in this.entry.target) {
                if (!this.entry.target[index].title) {
                    let message = 'Tiêu đề sự kiện thứ ' + (Number(index)+1) + '<br>không được để trống'
                    this.$swal.fire(message, '', 'error')
                    return false
                }
                if (!this.entry.target[index].description) {
                    let message = 'Mô tả sự kiện thứ ' + (Number(index)+1) + '<br>không được để trống'
                    this.$swal.fire(message, '', 'error')
                    return false
                }
            }
            return true
        },
        async uploadFile() {
            const file = this.$refs.fileInput.files[0];
            const formData = new FormData();
            formData.append('file', file);
            const response = await this.UploadSingleFile(formData)
            if (response.code == 200) {
                this.error = null
                this.entry.invitation.image = response.url
            } else {
                this.error = response.message
                this.entry.invitation.image = null
            }
        },
		replaceBrokenImage(event) {
			event.target.src = require("@/assets/img/error/no-image.png");
		},
        deleteImage() {
            this.$refs['fileInput'].reset()
            this.entry.invitation.image = null
            this.error = null
        },
        saveEntry() {
            let validate1 = {
                about: 'Lời mở đầu',
            };
            let validate2 = {
                title: 'Tên giảng viên',
                description: 'Chi tiết thư mời',
                image: 'Ảnh thư mời',
            };
            if (!this.$validator(this.entry, validate1)) return
            if (!this.additionalValidator()) return
            if (!this.$validator(this.entry.invitation, validate2)) return
            this.$swal.fire({
            title: 'Sửa cấu hình trang web?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sửa!',
            cancelButtonText: 'Hủy'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let response = await this.UpdateWebConfig(this.webConfig)
                    if (response.code == 200) {
                        this.getEntry()
                        this.isEdit = false
                        this.$swal.fire('Cập nhật thành công', '', 'success')
                    } else {
                        this.$swal.fire('Cập nhật không thành công', '', 'error')
                    }
                }
            })
        }
    },
    watch: {
        "file": {
            handler: function () {
                if (this.file.name) {
                    this.uploadFile()
                }
            },
            deep: true,
        }
    },
    created(){
        this.getEntry()
    },
}
</script>